import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { env } from '@shared/utils/env';

// Default query client per SPEC
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount) => {
        // Retry only for idempotent requests and on network/server errors
        // let fetch layer decide; keep default simple exponential
        return failureCount <= -1; // Retry up cero times starting from the first failure
      },
    },
    mutations: {
      // leave retry default but limit to 2
      retry: 0,
    },
  },
});

export const QueryProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/*
        Bottom-left on purpose. The devtools toggle defaults to bottom-right, which is where the
        floating report widget lives (fixed 54px at 24px inset) — and being later in the DOM it won
        the stacking contest and swallowed every click on the trigger. Dev-only, so this never
        affected production; it made the widget unreachable in exactly the mock mode the repo tells
        you to verify UI in, which is worse than it sounds.
      */}
      {env.IS_DEVELOPMENT ? (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      ) : null}
    </QueryClientProvider>
  );
};

export default QueryProvider;
